import EndUserScanIndex from 'components/endUserScan/index';

const EndUserScan = () => {
	return <EndUserScanIndex />;
};

export default EndUserScan;
